import { render, staticRenderFns } from "./CamposAccordion.vue?vue&type=template&id=b710eab8&scoped=true"
import script from "./CamposAccordion.vue?vue&type=script&lang=js"
export * from "./CamposAccordion.vue?vue&type=script&lang=js"
import style0 from "./CamposAccordion.vue?vue&type=style&index=0&id=b710eab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b710eab8",
  null
  
)

export default component.exports